<template>
  <div class="pageContent">
    <!--顶部一条-->
    <pageTitle title='修改手机号' />
  
    <div style="height: 0.5rem"></div>
    <div align="center">
      <div style=" width:90% ;    " align="left">
  
        <div style="height: 0.8rem">
          <span style="font-size:0.28rem ; color:#666666 ; font-weight:bold"> 登录密码 </span>
          <span style="0.38rem"></span>
          <input v-model="PassWord" type="password" placeholder="请输入登录密码"  style="  height:0.5rem ; font-size:0.28rem  ;  margin-left:0.3rem  ; width:5rem  ;border:0 ;  outline:0 ;  " />
        </div>
        <mu-divider />

        <div style="height: 0.8rem ; margin-top:0.4rem ">
          <span style="font-size:0.28rem ; color:#666666 ; font-weight:bold"> 新手机号 </span>
          <!--<span style="margin-left:0.28rem"></span>-->
          <input v-model="UserPhone"  placeholder="请输入您的手机号"  style=" height:0.5rem ; font-size:0.28rem  ;  margin-left:0.3rem  ; width:5rem  ;border:0 ;  outline:0 ;  "  />
        </div>
        <mu-divider />
  
        <div style="height: 0.8rem ; margin-top:0.4rem  ">
          <span style="font-size:0.28rem ; color:#666666 ; font-weight:bold"> 附加码 </span>
          <span style="margin-left:0.28rem"></span>
          <input v-model="FJM" style="  height:0.5rem ; font-size:0.28rem  ;  margin-left:0.3rem  ; width:2.8rem  ;border:0 ;  outline:0 ;  " placeholder="请输入附加码" />
          <img v-bind:src="TPFJM" style=" width: 1.9rem ; float:right ;margin-top:-0.2rem " v-on:click="this.getValidateCode" />
        </div>
        <mu-divider />
  
        <div style="height: 0.8rem ; margin-top:0.4rem  ">
          <span style="font-size:0.28rem ; color:#666666 ; font-weight:bold"> 验证码 </span>
          <span style="margin-left:0.28rem"></span>
          <input v-model="YZM" style="  height:0.5rem ; font-size:0.28rem  ;  margin-left:0.3rem  ; width:2.8rem  ;border:0 ;  outline:0 ;  " placeholder="请输入验证码" />
          <span v-on:click="getYZM" v-show="haveYZM == false">
            <input id="getYZM" type="button" value="获取" style="font-size:0.32rem ; float:right;   background-color:#27ba69 ; height: 0.75rem  ; border:none  ;  width: 1.9rem ;  color:white" />
          </span>
          <span   v-show="haveYZM == true">
            <input id="getYZM" type="button" v-model="WaitTime" style="font-size:0.32rem ; float:right;   background-color:#eeeeee ;   height: 0.75rem  ; border:none  ;  width: 1.9rem ; color:#999 ;" />
          </span>
        </div>
        <mu-divider />
  
      </div>
    </div>
  
    <div align="center">
      <mu-raised-button label="修 改" primary="" @click="Change" v-bind:style="{ width:'90%',height:' 1rem' }" style="font-size:0.3rem  ; margin-top: 0.6rem ;" />
    </div>
    <br />
    <br />
    <br />
    <br />

    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message="this.TellUser" @close="hideToast" id="alertline" />
  
  </div>
</template>




<style lang="less" scoped="">
@import "../../assets/theme.less";



#greenfont {
  color: @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}
</style>





<script>


import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'


export default {
  data() {

    return {

      //  输入框初始化  
      PassWord :'',
      UserPhone: '',
      TPFJM: '',
      FJM: '',
      YZM: '',
      haveYZM: false,
      WaitTime: '',
      Time: 29 ,

      //  输入框初始化  END  


      // 弹出层 弹出内容
      toast: false,
      TellUser: '',
      // 弹出层 弹出内容  END

    }
  },
  // 数据获取
  computed: {
    ...mapGetters([
      'g_UserInfo',
    ])
  },
  activated() {

    this.PassWord = '';
    this.UserPhone = '';
    this.FJM = '';
    this.YZM = '';

    this.getValidateCode();

  },
  methods: {
    ...mapMutations([
      'setG_UserInfo',
    ]),


    // 后退一页
    goback() {
      javascript: history.go(-1);
    },

    // 图片验证码
    getValidateCode() {
      this.TPFJM = api.getValidateCode();
    },



    //  获取验证码
    getYZM() {
      
      if (this.UserPhone == '') {
        this.TellUser = '请输入您的手机号';
        this.showToast();
      }
      else if (this.FJM == '') {
        this.TellUser = '请输入附加码';
        this.showToast();
      }
      else {

        // 开始计时
        this.haveYZM = true;
        this.WaitTime = this.Time + "秒"
        this.timer();


        var params = new this.URLSearchParam();
        params.append('mobile', this.UserPhone);
        params.append('captcha', this.FJM);
        params.append('password', this.PassWord);

        this.$http.post(api.SMSChangePhone(), params.toParam()).then((res) => {

          console.log(res)
          if (res.Result == true) {

            this.TellUser = res.Data;
            this.showToast();

          }
          else {  //登陆失败
            this.TellUser = res.Message;
            this.showToast();
            this.getValidateCode();

            this.Time = 5 ;
          }
        })
      }
    },
    timer() {
      if (this.Time > 0) {
        this.Time--;
        this.WaitTime = this.Time + "秒"
        
        setTimeout(this.timer, 1000);
      }
      else if (this.Time == 0) {
        this.haveYZM = false;
        this.Time = 29;
      }
    },
    //  获取验证码  END





    //  修改
    Change() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入您的手机号';
        this.showToast();
      }
      else if (this.YZM == '') {
        this.TellUser = '请输入收到的验证码';
        this.showToast();
      }
      else{

        var params = new this.URLSearchParam();
        params.append('NewPhone', this.UserPhone);
        params.append('phoneyzm', this.YZM);
        params.append('password', this.PassWord);

        this.$http.post(api.ChangePhone(), params.toParam()).then((res) => {

          if (res.Result == true) {
            this.TellUser = res.Data;
            this.showToast();


            // 修改缓存中的
            var UserInfo = this.g_UserInfo;
            UserInfo.sjno = this.UserPhone;
            this.setG_UserInfo(UserInfo);

                    
            setTimeout(() => { this.$router.push({ path: '/user/UserCenter' }) }, 1800)
            
          }
          else {  //登陆失败
            this.TellUser = res.Message;
            this.showToast();
          }
        })

      }
    },
    //  获取验证码  END


    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1500)
      if (this.TellUser == '未登录') {
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1800)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end




  }
}



</script>










// WEBPACK FOOTER //
// ChangePhone.vue?44984027